<template>
  <div >
    <!-- 顶部菜单 -->
    <Header :path ='key' v-if="!$route.meta.hideTop" />
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view :key="key" />
    </keep-alive >
    <router-view :key="key" v-else/>
    <!-- 底部版权 -->
    <Footer v-if="!$route.meta.hideFooter" />
    <!-- <advice-btn  v-if="$route.path=='/' || $route.path =='/index'"/> -->
    <div class="slidebtn">
        <qrbtn />
       <advice-btn v-if="$route.path!='/advice' && $route.path.indexOf('register')<0 && $route.path.indexOf('login')<0" />
      <back-top />
    </div> 
    
    <!-- <transition name="fade">
      <loading-page v-if="pageChange"/>
    </transition> -->
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '../components/footer.vue'
import Home from '../pages/Home.vue';
import BackTop from '../components/back-top.vue';
import LoadingPage from '../components/common/loadingPage.vue';
import Guid from './guid.vue';
import AdviceBtn from '../components/common/adviceBtn.vue';
import Qrbtn from '../components/qrbtn.vue';

import Vue from "vue"
export default {
  name: 'layout',
  components: {
    Header,Footer,Home,
    BackTop,
    LoadingPage,
    Guid,
    AdviceBtn,
    Qrbtn,
    
  },
  props: {
    msg: String
  },
  data(){
    return{
      name:"122",
      transitionName:'',
      pageChange:false
    }
  },
  computed:{
    key(){
      return this.$route.fullPath;
    },
  },
  mounted() {
    
    // this.getDownload()
    
  },
  methods: {
    
  },
}
</script>
<style scoped >

.slide-up-enter {
  transform: translateY(100%)
}
.slide-up-leave-to {
  /* // transform: translateY(-100%) */
}
.slide-up-enter-active, .slide-up-leave-active{
  transition: 1.5s;
  position: absolute;
  left:0;
}


</style>